import { getEntities, isFetching, isCreating, isDeleting, getCreateError } from './_utils'

export const getPaymentMethods = getEntities('paymentMethods')
export const fetchingPaymentMethods = isFetching('/users/profile/payment_methods')
export const creatingPaymentMethod = isCreating('/users/profile/payment_methods')
export const deletingPaymentMethod = (state, id) => isDeleting(`/users/profile/payment_methods/${id}`)(state)
export const getCreatePaymentMethodError = getCreateError('/users/profile/payment_methods')
